<template>
<span class="small-block">
  <div class="bj">
    <img v-if="color=='yellow'" src="/static/images/svolt/nanwang/small-block-yellow-bj.png" />
    <img v-if="color=='blue'" src="/static/images/svolt/nanwang/small-block-blue-bj.png" />
  </div>
  <div class="content">
    <div class="s-title">{{data.title}}</div>
    <div class="s-number" :class="{'s-blue':color=='bluex','s-yellow':color=='bluex','s-green':color=='green'}">{{data.number}}<span class="unit">{{data.unit}}</span></div>
  </div>
</span>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    },
    color: {
      type: String
    },
    width: {
      type: [Number, String],
      default: 124
    },
    height: {
      type: [Number, String],
      default: 42
    }
  },
  data() {
    return {
      title: ''
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss">
.small-block {
  position: relative;
  top: 0;
  left: 0;
  width: 130px;
  height: 48px;
  overflow: hidden;
  display: inline-block;

  .bj {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
    width: 100%;

    img {
      width: 100%;
      height: 48px;
    }
  }

  .content {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 10;
    width: 100%;
    min-width: max-content;
    height: 53px;
    text-align: center;

    .s-title {
      width: 100%;
      text-align: center;
      margin-top: 8px;
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #5E688F;
    }

    .s-number {
      font-family: DINBold, DINAlternate;
      margin-top: 2px;
      font-size: 20px;
      font-weight: bold;
      color: #08265F;

      .unit {
        font-size: 14px;
        margin-left: 4px;
      }
    }

    .s-blue {
      color: #76DEFC !important;
    }

    .s-yellow {
      color: #FFD478 !important;
    }

    .s-green {
      color: #77FFA7 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/small-block.vue